"use strict";

exports.__esModule = true;
exports.SectionLabelElement = SectionLabelElement;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Device = require("../../Device");
var _common = require("../common");
var _excluded = ["content", "color", "backgroundColor", "theme"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// A section label is a note, not a headline: the configured size is honoured
// up to this, so a block of explanatory text stays compact and wraps.
var MAX_FONT_SIZE = 15;
var LINE_HEIGHT = 1.35;
var DEFAULT_COLOR = "#5a6771";

// "- Red if ..." style legend lines get a swatch in place of the dash, in the
// plant's own state colours.
var SWATCH = /^\s*[-•*]\s*(red|orange|amber|yellow|green|grey|gray|blue)\b/i;
var SWATCH_TOKENS = {
  red: "UnplannedDowntimeStateColor",
  orange: "PlannedDowntimeStateColor",
  amber: "PlannedDowntimeStateColor",
  yellow: "PlannedDowntimeStateColor",
  green: "ProducingStateColor"
};
var Note = _styledComponents["default"].div.withConfig({
  displayName: "SectionLabelElementmodern__Note",
  componentId: "sc-161uf1n-0"
})(["box-sizing:border-box;display:flex;align-items:center;gap:8px;overflow:hidden;line-height:", ";"], LINE_HEIGHT);
var Swatch = _styledComponents["default"].span.withConfig({
  displayName: "SectionLabelElementmodern__Swatch",
  componentId: "sc-161uf1n-1"
})(["flex:none;width:10px;height:10px;border-radius:3px;"]);
var Text = _styledComponents["default"].span.withConfig({
  displayName: "SectionLabelElementmodern__Text",
  componentId: "sc-161uf1n-2"
})(["min-width:0;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;"]);
var isPlainBackground = function isPlainBackground(color) {
  return !color || color === "transparent" || /^#?(fff|ffffff)$/i.test(color) || /^rgba?\(\s*255\s*,\s*255\s*,\s*255\s*(,\s*[01]?(\.\d+)?)?\s*\)$/i.test(color);
};
function NoteContent(props) {
  var content = props.content,
    color = props.color,
    backgroundColor = props.backgroundColor,
    theme = props.theme,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var width = rest.width,
    height = rest.height,
    fontSize = rest.fontSize,
    fontWeight = rest.fontWeight,
    fontStyle = rest.fontStyle,
    fontFamily = rest.fontFamily,
    textAlignment = rest.textAlignment;
  var text = content == null ? "" : String(content);
  var size = Math.min(fontSize || 14, MAX_FONT_SIZE);
  var lines = Math.max(1, Math.floor(height / (size * LINE_HEIGHT)));
  var banner = !isPlainBackground(backgroundColor);
  var swatch = null;
  var body = text;
  var match = SWATCH.exec(text);
  if (match) {
    var name = match[1].toLowerCase();
    swatch = SWATCH_TOKENS[name] ? theme[SWATCH_TOKENS[name]] || name : name;
    body = text.slice(match[0].length - match[1].length);
  }
  var justify = textAlignment === "center" ? "center" : textAlignment === "right" ? "flex-end" : "flex-start";
  return /*#__PURE__*/_react["default"].createElement(Note, _extends({
    style: {
      width: width,
      height: height,
      justifyContent: justify,
      padding: banner ? "6px 12px" : "0 4px",
      borderRadius: banner ? 8 : 0,
      background: banner ? backgroundColor : "transparent",
      color: color || (banner ? "#1b2227" : DEFAULT_COLOR),
      fontSize: size,
      fontWeight: fontWeight || 500,
      fontStyle: fontStyle,
      fontFamily: fontFamily
    }
  }, (0, _common.getWidgetInteractionProps)(rest), {
    "data-testid": "SectionLabel"
  }), swatch && /*#__PURE__*/_react["default"].createElement(Swatch, {
    style: {
      background: swatch
    }
  }), /*#__PURE__*/_react["default"].createElement(Text, {
    style: {
      WebkitLineClamp: lines
    },
    title: text
  }, body));
}

/**
 * Displays a label for a section as a compact note: the configured size is a
 * cap, the text wraps to the lines that fit, legend lines get a colour
 * swatch, and a configured background becomes a rounded banner.
 */
function SectionLabelElement(props) {
  var content = props.content,
    color = props.color,
    backgroundColor = props.backgroundColor,
    backgroundColorSource = props.backgroundColorSource;
  var device = (0, _react.useContext)(_Device.DeviceContext);
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext) || {};
  var position = (0, _common.getWidgetPositionProps)(props);
  if (backgroundColorSource && device) {
    return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
      deviceUuid: device.uuid
    }, (0, _common.getWidgetColorProps)(props)), function (_ref) {
      var sourced = _ref.color,
        sourcedBackground = _ref.backgroundColor;
      return /*#__PURE__*/_react["default"].createElement(NoteContent, _extends({}, props, position, {
        content: content,
        color: sourced,
        backgroundColor: sourcedBackground,
        theme: theme
      }));
    });
  }
  return /*#__PURE__*/_react["default"].createElement(NoteContent, _extends({}, props, position, {
    content: content,
    color: color,
    backgroundColor: backgroundColor,
    theme: theme
  }));
}